export const admin = {
  "admin.title": "Suji Admin",
  "admin.checking_permissions": "Checking permissions...",
  "admin.suppliers": "Suppliers",
  "admin.users": "Users",
  "admin.reviews": "Reviews",
  "admin.total_revenue": "Total Revenue",
  "admin.pending_suppliers": "Pending Suppliers",
  "admin.name": "Name",
  "admin.email": "Email",
  "admin.category": "Category",
  "admin.actions": "Actions",
  "admin.approve": "Approve",
  "admin.reject": "Reject",
  "admin.no_pending_suppliers": "No pending suppliers",
  "admin.confirm_reject": "Are you sure you want to reject this supplier? This action cannot be undone.",
  "admin.recent_activity": "Recent Activity",
  "admin.latest_reviews": "Latest Reviews",
  "admin.no_reviews": "No reviews",
  "admin.category_management": "Category Management",
  "admin.delete_category": "Delete Category",
  "admin.init_categories": "Initialize Categories",
  "admin.add_category": "Add Category",
  "admin.new_category": "New Category",
  "admin.edit_category": "Edit Category",
  "admin.category_name": "Category Name",
  "admin.icon": "Icon",
  "admin.description": "Description",
  "admin.display_order": "Display Order",
  "admin.placeholder_category": "Enter category name",
  "admin.placeholder_icon": "Enter Remix Icon class",
  "admin.placeholder_description": "Enter category description",
  "admin.active": "Active",
  "admin.inactive": "Inactive",
  "admin.add": "Add",
  "admin.cancel": "Cancel",
  "admin.save": "Save",
  "admin.edit": "Edit",
  "admin.delete": "Delete",
  "admin.confirm_delete": "Are you sure you want to delete this category?",
  "admin.confirm_init": "Are you sure you want to initialize categories? This will add default categories if they don't exist.",
  "admin.init_success": "Categories initialized successfully!",
  "admin.name_required": "Category name is required",
  "admin.category_added_success": "Category added successfully",
  "admin.error_add_category": "Error adding category",
  "admin.category_updated_success": "Category updated successfully",
  "admin.error_update_category": "Error updating category",
  "admin.category_deleted_success": "Category deleted successfully",
  "admin.error_delete_category": "Error deleting category",
  "admin.overview": "Overview",
  "admin.overview_description": "Manage your platform and track performance in real-time.",
  "admin.supplier_management": "Supplier Management",
  "admin.supplier_management_description": "Approve or reject supplier applications.",
  "admin.category_management_description": "Manage business categories on the platform.",
  "admin.premium_suppliers": "Premium Suppliers",
  "admin.premium_suppliers_description": "Manage premium suppliers displayed on the homepage.",
  "admin.all_premium_suppliers": "All Premium Suppliers",
  "admin.premium_status": "Premium Status",
  "admin.set_premium": "Set Premium",
  "admin.remove_premium": "Remove Premium",
  "admin.premium": "Premium",
  "admin.not_premium": "Not Premium",
  "admin.featured": "Featured",
  "admin.not_featured": "Not Featured",
  "admin.no_premium_suppliers": "No premium suppliers",
  "admin.error_approve_supplier": "Error approving supplier",
  "admin.error_reject_supplier": "Error rejecting supplier",
  "admin.error_delete_supplier": "Error deleting supplier",
  "admin.error_init_categories": "Error initializing categories",
  "admin.error_set_featured": "Error setting featured status",
  "admin.error_remove_featured": "Error removing featured status",
  "admin.admin_panel": "Admin Panel",
  "admin.all_suppliers": "All Suppliers",
  "admin.total_suppliers": "Total Suppliers",
  "admin.status": "Status",
  "admin.approved": "Approved",
  "admin.pending": "Pending",
  "admin.verified": "Verified",
  "admin.yes": "Yes",
  "admin.no": "No",
  "admin.view": "View",
  "admin.feature": "Feature",
  "admin.unfeature": "Unfeature",
  "admin.no_suppliers": "No suppliers",
  "admin.supplier_details": "Supplier Details",
  "admin.location": "Location",
  "admin.phone": "Phone",
  "admin.website": "Website",
  "admin.created_at": "Created At",
  "admin.updated_at": "Updated At",
  "admin.close": "Close",
  "admin.confirm_delete_supplier": "Are you sure you want to delete this supplier? This action cannot be undone.",
  "admin.confirm": "Confirm",
  "admin.approve_supplier": "Approve Supplier",
  "admin.confirm_approve_supplier": "Are you sure you want to approve this supplier?",
  "admin.supplier_approved": "Supplier approved successfully",
  "admin.supplier_featured": "Supplier set as featured",
  "admin.supplier_unfeatured": "Supplier removed from featured",
  "admin.delete_supplier": "Delete Supplier",
  "admin.supplier_deleted": "Supplier deleted successfully",
  "admin.no_categories": "No categories",
  "admin.category_image": "Category Image",
  "admin.placeholder_image": "Enter image URL",
  "admin.image": "Image",
  "admin.reject_supplier": "Reject Supplier",
  "admin.supplier_rejected": "Supplier rejected successfully",
  "admin.products": "Products",
  "admin.products_description": "Manage and track all products across the platform.",
  "admin.galleries": "Galleries",
  "admin.categories": "Categories",
  "admin.products_management_description": "Track and manage all products across the platform.",
  "admin.total_products": "Total Products",
  "admin.active_products": "Active Products",
  "admin.inactive_products": "Inactive Products",
  "admin.total_stock": "Total Stock",
  "admin.all_products": "All Products",
  "admin.price": "Price",
  "admin.stock": "Stock",
  "admin.supplier": "Supplier",
  "admin.product_details": "Product Details",
  "admin.images": "Images",
  "admin.no_products": "No products",
  "admin.order": "Order",
  "admin.no_orders": "No orders",
  "admin.delete_all_suppliers": "Delete All Suppliers",
  "admin.confirm_delete_all_suppliers": "Are you sure you want to delete ALL suppliers? This action cannot be undone and will remove all supplier data from the platform.",
  "admin.delete_all_suppliers_success": "All suppliers deleted successfully",
  "admin.error_delete_all_suppliers": "Error deleting all suppliers",
  "admin.init_categories_disabled": "Categories initialization is disabled",
  "admin.refresh": "Refresh",
  "admin.refresh_suppliers": "Refresh suppliers list",
  "admin.suppliers_refreshed": "Suppliers list refreshed",
  
  "admin.search_icons": "Search icons...",
  "admin.image_url_placeholder": "https://example.com/image.jpg",
  "admin.notification_title": "Notification title",
  "admin.notification_message": "Message",
  "admin.notification_type": "Type",
  "admin.send": "Send",
  "admin.sending": "Sending...",
  "admin.send_notification": "Send notification",
  "admin.notifications": "Notifications",
  "admin.type_system": "System",
  "admin.type_order": "Order",
  "admin.type_review": "Review",
  "admin.type_message": "Message",
  "admin.type_verification": "Verification",
  "admin.type_approval": "Approval",
  "admin.all_users": "All users",
  "admin.filter_by_category": "Filter by category",
  "admin.notifications_history": "Notifications history",
  "admin.date": "Date",
  "admin.sent_by": "Sent by",
  "admin.sent_to": "Sent to",
  "admin.preview": "Preview",
  "admin.sent": "Sent",
  "admin.no_notifications": "No notifications",
  "admin.user": "User",
  "admin.recipient_type": "Recipient type",
  "admin.select_type": "Select type",
  "admin.fill_all_fields": "Please fill all fields",
  "admin.notification_sent": "Notification sent successfully",
  "admin.error_sending_notification": "Error sending notification",
  "admin.error_fetching_notifications": "Error fetching notifications",
  "admin.notification_title_placeholder": "e.g. New feature announcement",
  "admin.notification_message_placeholder": "Content of the notification",
  "admin.action_link": "Action link (optional)",
  "admin.notification_url_placeholder": "/dashboard or https://…",
  "admin.send_to_all_users": "Send to all users",
  "admin.send_notification_button": "Send notification",
  "admin.notification_sent_to_count": "Notification sent to {{count}} users",
  "admin.select_user_or_all": "Please select a recipient or check \"Send to all users\"",
  "admin.user_search": "Recipient",
  "admin.user_search_placeholder": "Search by name or email...",
  "admin.user_search_help": "Type at least 2 characters (name or email), then select the user from the list.",
  "admin.user_search_no_results": "No users found",
  "admin.user_search_min_chars": "Type at least 2 characters to search",
  "admin.user_search_error": "Error while searching. Please try again.",
  "admin.user_without_name": "Unnamed user",

  // Newsletter & emails (admin tab)
  "admin.newsletter": "Newsletter & Emails",
  "admin.newsletter_description": "Send campaigns to newsletter subscribers and monitor email delivery.",
  "admin.newsletter_campaign": "Send a campaign",
  "admin.newsletter_subject": "Subject",
  "admin.newsletter_subject_placeholder": "Your campaign subject",
  "admin.newsletter_content": "Content (HTML)",
  "admin.newsletter_content_placeholder": "HTML content of the campaign",
  "admin.newsletter_send": "Send campaign",
  "admin.newsletter_sent": "Campaign scheduled for {{count}} subscribers",
  "admin.newsletter_send_error": "Error while sending the campaign",
  "admin.newsletter_fields_required": "Subject and content are required",
  "admin.newsletter_subscribers": "Subscribers",
  "admin.newsletter_filter_active": "Active",
  "admin.newsletter_filter_unsubscribed": "Unsubscribed",
  "admin.newsletter_no_subscribers": "No subscribers",
  "admin.newsletter_sector": "Sector",
  "admin.newsletter_subscribed_at": "Subscribed on",
  "admin.newsletter_status_active": "Active",
  "admin.newsletter_status_unsubscribed": "Unsubscribed",
  "admin.email_log": "Email delivery log",
  "admin.email_log_recipient": "Recipient",
  "admin.email_log_subject": "Subject",
  "admin.email_log_error": "Error",
  "admin.email_log_failed": "Failed",
  "admin.email_log_sent_total": "Sent emails",
  "admin.email_log_failed_total": "Failed emails",
  "admin.email_log_empty": "No emails logged yet",
  "admin.email_log_filter_sent": "Sent only",
  "admin.email_log_filter_failed": "Failed only",

  // Filter and sorting
  "admin.all": "All",
  "admin.search": "Search",
  "admin.sort_by": "Sort by",
  "admin.reset": "Reset",
  "admin.all_categories": "All Categories",
  "admin.search_placeholder": "Search by name, email, city...",
  "admin.search_categories_placeholder": "Search by name or description...",
  "admin.search_products_placeholder": "Search by name or description...",
  "admin.newest_first": "Newest First",
  "admin.oldest_first": "Oldest First",
  "admin.name_az": "Name (A-Z)",
  "admin.name_za": "Name (Z-A)",
  "admin.category_az": "Category (A-Z)",
  "admin.city_az": "City (A-Z)",
  "admin.price_low_high": "Price (Low to High)",
  "admin.price_high_low": "Price (High to Low)",
  "admin.stock_low_high": "Stock (Low to High)",
  "admin.stock_high_low": "Stock (High to Low)",
  "admin.out_of_stock": "Out of Stock"
};

export default admin;